import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES } from "@/config/site";

export default function Footer() {
  return (
    <footer className="bg-deep-blue text-white/80 mt-24">
      <div className="container-editorial py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-3">
            <span className="font-display text-4xl text-white">{COMPANY.name}</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-terracotta">Rénovation</span>
          </div>
          <p className="mt-6 text-white/60 max-w-md leading-relaxed">
            {COMPANY.tagline}. Nous mettons en relation particuliers et professionnels avec des artisans qualifiés en Indre-et-Loire et Centre-Val de Loire.
          </p>

          <div className="mt-8 space-y-3 text-sm">
            <a href={COMPANY.phoneHref} className="flex items-center gap-3 hover:text-terracotta transition-colors">
              <Phone className="w-4 h-4" strokeWidth={1.5} />
              <span>{COMPANY.phone}</span>
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-terracotta transition-colors">
              <Mail className="w-4 h-4" strokeWidth={1.5} />
              <span>{COMPANY.email}</span>
            </a>
            <div className="flex items-center gap-3">
              <MapPin className="w-4 h-4" strokeWidth={1.5} />
              <span>{COMPANY.address}</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] uppercase tracking-[0.28em] text-terracotta mb-6">Navigation</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">Accueil</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors">Nos services</Link></li>
            <li><Link to="/realisations" className="hover:text-white transition-colors">Réalisations</Link></li>
            <li><Link to="/a-propos" className="hover:text-white transition-colors">À propos</Link></li>
            <li><Link to="/temoignages" className="hover:text-white transition-colors">Témoignages</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.28em] text-terracotta mb-6">Nos métiers</div>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
            {SERVICES.slice(0, 11).map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="hover:text-white transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>

          <Link
            to="/contact"
            className="mt-8 inline-flex items-center gap-2 bg-terracotta hover:bg-copper text-white px-5 py-3 text-sm tracking-wide transition-colors"
            data-testid="footer-cta-quote"
          >
            Demander un devis
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-editorial py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} {COMPANY.name}. Tous droits réservés. — SIRET {COMPANY.siret}</div>
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2" aria-label="Documents légaux">
            <Link to="/mentions-legales" data-testid="footer-legal" className="hover:text-white transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" data-testid="footer-rgpd" className="hover:text-white transition-colors">RGPD</Link>
            <Link to="/cgv" data-testid="footer-cgv" className="hover:text-white transition-colors">CGV</Link>
          </nav>
          <div className="flex items-center gap-4">
            <a href={COMPANY.socials.instagram} aria-label="Instagram" className="hover:text-white transition-colors"><Instagram className="w-4 h-4" strokeWidth={1.5} /></a>
            <a href={COMPANY.socials.facebook} aria-label="Facebook" className="hover:text-white transition-colors"><Facebook className="w-4 h-4" strokeWidth={1.5} /></a>
            <a href={COMPANY.socials.linkedin} aria-label="LinkedIn" className="hover:text-white transition-colors"><Linkedin className="w-4 h-4" strokeWidth={1.5} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
